export const itemsActions = [
  {
    key: 'edit',
    label: 'Edit'
  }
]
